
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shop/team/create",
      function () {
        return require("private-next-pages/shop/team/create.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shop/team/create"])
      });
    }
  